const escapeForRegex = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const filesApiHosts = [
  'res-test.listglobally.com',
  'res.listglobally.com',
  'files-api-test.properstar.com',
  'files-api.properstar.com',
  'communications-api-test.listglobally.com',
  'communications-api.listglobally.com',
]

export const filesApiPattern = new RegExp(
  `https?://(${filesApiHosts.map(escapeForRegex).join('|')})`
)

export const MIN_IMAGE_ATTACHMENT_SIZE = 200
